import React from 'react'
import styles from './add-school.styles'
import injectSheet from 'react-jss'
import Wrapper from '../../../../../wrapper/wrapper'
import Container from '../../../../../container/container'
import Description from '../../../../../description/description'
import duck from '../../../../../images/su-duck.gif'
import AddSchoolForm from './add-school-form/add-school-form'
import BackButton from '../../../../../back-button/back-button'
import { apiSetRoleInLife } from '../../../../../../common/api/profile'
import { useMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'

const AddSchool = ({ classes, clearState }) => {
  const { refetchMe } = useMe()
  return (
    <Wrapper>
      <Container primary img={duck}>
        <Description title="Add your school">
          <BackButton
            bottomMargin
            onClick={() => {
              apiSetRoleInLife({
                role_in_life: null
              })
                .then(() => {
                  return refetchMe().then(clearState)
                })
                .catch(errorHandler)
            }}>
            Back to role selection
          </BackButton>
        </Description>
        <AddSchoolForm />
      </Container>
    </Wrapper>
  )
}

export default injectSheet(styles)(AddSchool)
